import { CloseSharp, DeleteSharp, SaveSharp } from "@mui/icons-material";
import { Autocomplete, Button, Grid, IconButton, Stack, TextField } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useContext, useEffect, useState } from "react";
//import DialogTitle from "@mui/material/DialogTitle";
import { useTheme } from "@mui/material/styles";
import { format } from "date-fns";
import { Formik } from "formik";
import { useTranslation } from "react-i18next";
import * as Yup from "yup";
import axios from "../../axiosInstances";
import { ShoppingCartContext } from "../Context/ShoppingCartContext";
const validationSchema = Yup.object().shape({
  Price: Yup.number().required("Price is required!!!"),
  Store: Yup.string()
    .min(1, "Store is required!!")
    .required("Store is required!!!"),
  DefaultOrderQty: Yup.number().required("Default Ord Qty is required!!!")
});
export default function StockBalancesModel(props) {
  const theme = useTheme();
  const { t, i18n } = useTranslation();

  const [open, setOpen] = useState(false);
  const { globalUser, globalStores, globalToken, globalRoleSecurity } =
    useContext(ShoppingCartContext);
  var fileObj = [];
  var fileArray = [];
  const [id, setId] = useState(props.data.Id);
  const [item, setItem] = useState(props.data.Item);
  const [storeList, setStoreList] = useState(globalStores);
  const [store, setStore] = useState(
    props.data
      ? storeList.filter((st) => parseInt(st.Id) === parseInt(props.data.Store))
        .length > 0
        ? storeList.filter(
          (st) => parseInt(st.Id) === parseInt(props.data.Store)
        )[0].Name
        : null
      : null
  );

  const [itemName, setItemName] = useState(props.data.Name);
  const [reference, setReference] = useState(props.data.ReferenceNo);
  const [expiryDate, setExpiryDate] = useState(
    props.data.expiryDate
      ? props.data.ExpiryDate
      : format(new Date(), "yyyy-MM-dd")
  );
  const [manufacturingCountry, setManufacturingCountry] = useState(
    props.data.MfrCountry
  );
  const [manufacturingDate, setManufacturingDate] = useState(
    props.data.MfrDate ? props.data.MfrDate : format(new Date(), "yyyy-MM-dd")
  );
  const [quantity, setQuantity] = useState(props.data.Quantity);
  const [price, setPrice] = useState(props.data.Price);
  const [defaultOrderQty, setDefaultOrderQty] = useState(
    props.data.DefaultOrderQty
  );
  const [parentCategoriesList, setParentCategoriesList] = useState([]);
  const recalculateBalancesList = () => {
    axios.get("/stockBalances/RecalculatePerItem?Parent=" + globalUser.Parent + "&Item=" + id, {
      headers: {
        token: globalToken,
      },
    })

  };
  const handleSubmit = (all) => {
    if (store === undefined || store === null || store.length <= 0) {
      alert("First select the store ");
      return;
    }
    if (window.confirm("Are you sure you want to save?")) {

      try {
        var fd = new FormData();
        fd.append("Id", id ? id : 0);
        fd.append("Item", item);
        fd.append("Supplier", globalUser.Parent);

        fd.append("Reference", reference);

        fd.append(
          "Store",
          storeList && storeList.filter((st) => st.Name === store).length > 0
            ? storeList.filter((st) => st.Name === store)[0].Id
            : 0
        );

        fd.append("ExpiryDate", expiryDate);
        fd.append("MfrCountry", manufacturingCountry);
        fd.append("MfrDate", manufacturingDate);
        fd.append("Quantity", quantity);
        fd.append("Price", price);
        fd.append("DefaultOrderQty", defaultOrderQty);
        axios.post("/stockBalances", fd, {
          headers: {
            "Content-Type": "application/json",
            token: globalToken
          },
        });
      } catch (err) {
      } finally {
        props.setParentUpdate(!props.ParentUpdate);
        setOpen(false);
      }
    }
  };
  const handleDelete = () => {
    if (window.confirm("Are you sure you want to delete?")) {
      try {
        axios.delete("/stockBalances?Id=" + id, {
          headers: {
            token: globalToken,
          },
        });
      } catch (err) {
      } finally {
        props.setParentUpdate(!props.ParentUpdate);
        setOpen(false);
      }
    }
  };

  const getListOfCategories = () => {
    try {
      axios
        .get("/itemCategories", {
          headers: {
            token: globalToken,
          },
        })
        .then((result) => {
          setParentCategoriesList(result.data.data);
        });
    } catch (err) { }
  };

  useEffect(() => {
    getListOfCategories();
  }, []);

  return (
    <div width="500">
      <label onClick={() => setOpen(true)}>{props.icon}</label>
      <Formik
        initialValues={props.data}
        onSubmit={
          handleSubmit
        }
        validationSchema={validationSchema}
        enableReinitialize
      >
        {({ values, errors, handleChange, handleBlur, handleSubmit }) => (
          <Dialog
            maxWidth="md"
            /*      PaperProps={{
               sx: {
                 height: '80vh',   // 80% of viewport height
                 maxHeight: '90vh',
               },
             }} */
            PaperProps={{
              style: {
                borderRadius: 24,
                backgroundColor: '#fffcf9', // Warm off-white
                boxShadow: '0 8px 30px rgba(0,0,0,0.08)'
              }
            }}
            open={open}
            onClose={() => {
              setOpen(false);
            }}
            aria-labelledby="responsive-dialog-title"
          >
            <DialogTitle
              id="responsive-dialog-title"
              bgcolor={theme.palette.primary.main}
              color={theme.palette.primary.contrastText}
            >
              <Stack direction='row' style={{ flex: 1 }}>
                <div style={{ flex: 1 }}>

                  Item Id: {item} <br></br>
                  Item Name: {itemName}
                </div>
                <IconButton style={{ backgroundColor: theme.palette.primary.light }} onClick={() => setOpen(false)} size="small"><CloseSharp /></IconButton>
              </Stack>

            </DialogTitle>

            <DialogContent>
              <DialogContentText>
                <hr></hr>

                <Grid container>
                  <Grid item xs={12} md={6} mt={1}>
                    <Autocomplete
                      label="Stores"
                      id="Store"
                      size="small"
                      variant="standard"
                      value={store}
                      onChange={(e) => {
                        values.Store = e.target.textContent;
                        setStore(e.target.textContent);
                      }}
                      onBlur={handleBlur("Store")}
                      options={
                        (!(storeList === undefined) &&
                          !(storeList === null) &&
                          storeList.length > 0) ?
                          storeList.map((pro) => {
                            return pro.Name;
                          }) : ['']
                      }
                      sx={{ width: "95%" }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={t("Store")}

                        //error={!from ? true : false}
                        />
                      )}
                    />
                    {errors.Store && (
                      <span style={{ color: "red" }}> {errors.Store}</span>
                    )}
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      disabled={true}
                      size="small"
                      variant="standard"
                      label="Inventory"
                      defaultValue={quantity}
                      type="float"
                      maxRows={4}
                      sx={{ width: "95%", marginBottom: 2 }}
                      onChange={(e) => {
                        setQuantity(e.target.value);
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      size="small"
                      variant="standard"
                      label="Unit Sales Price"
                      type="float"
                      name="Price"
                      defaultValue={price}
                      sx={{ width: "95%", marginBottom: 2 }}
                      onChange={(e) => {
                        values.Price = e.target.value;
                        setPrice(e.target.value);
                      }}
                      onBlur={handleBlur("Price")}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                    {errors.Price && (
                      <span style={{ color: "red" }}> {errors.Price}</span>
                    )}
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      size="small"
                      variant="standard"
                      label="Default Order Quantity"
                      type="float"
                      name="DefaultOrderQty"
                      defaultValue={defaultOrderQty}
                      sx={{ width: "95%", marginBottom: 2 }}
                      onChange={(e) => {
                        values.DefaultOrderQty = e.target.value;
                        setDefaultOrderQty(e.target.value);
                      }}
                      onBlur={handleBlur("DefaultOrderQty")}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                    {errors.DefaultOrderQty && (
                      <span style={{ color: "red" }}> {errors.DefaultOrderQty}</span>
                    )}
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      size="small"
                      variant="standard"
                      label="Reference"
                      defaultValue={reference}
                      onChange={(e) => {
                        setReference(e.target.value);
                      }}
                      sx={{ width: "95%", marginBottom: 2 }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      size="small"
                      type="date"
                      variant="standard"
                      label="Expiry Date"
                      value={expiryDate}
                      onChange={(e) => {
                        setExpiryDate(e.target.value);
                      }}
                      sx={{ width: "95%", marginBottom: 2 }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      size="small"
                      variant="standard"
                      label="Manufacturing Country"
                      defaultValue={manufacturingCountry}
                      sx={{ width: "95%", marginBottom: 2 }}
                      onChange={(e) => {
                        setManufacturingCountry(e.target.value);
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      size="small"
                      variant="standard"
                      label="Manufacturing Date"
                      type="date"
                      defaultValue={manufacturingDate}
                      sx={{ width: "95%", marginBottom: 2 }}
                      onChange={(e) => {
                        setManufacturingDate(e.target.value);
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Grid>
                </Grid>

                <hr></hr>
              </DialogContentText>
            </DialogContent>
            <DialogActions
              style={{
                backgroundColor: theme.palette.primary.main,
                color: theme.palette.primary.contrastText,
                flexWrap: 'wrap',
              }}
            >
              {globalRoleSecurity.filter(
                (sec) => sec.Functionality === "Stock Balance" && sec.Security > 1
              ).length > 0 && (
                  <>
                    <Button
                      variant="standard"
                      sx={{
                        borderRadius: 5,
                        fontSize: "10px",
                        backgroundColor: theme.palette.primary.main,
                        '&:hover': { backgroundColor: theme.palette.primary.light }
                      }}
                      endIcon={<SaveSharp />}
                      autoFocus
                      onClick={() => handleSubmit(0)}
                    >
                      Save
                    </Button>
                    |
                    <Button
                      variant="standard"
                      sx={{
                        borderRadius: 5,
                        fontSize: "10px",
                        backgroundColor: theme.palette.primary.main,
                        '&:hover': { backgroundColor: theme.palette.primary.light }
                      }}
                      endIcon={<SaveSharp />}
                      autoFocus
                      onClick={() => handleSubmit(1)}
                    >
                      Save For All Stores
                    </Button>
                    |
                  </>
                )}
              {globalRoleSecurity.filter(
                (sec) => sec.Functionality === "Stock Balance" && sec.Security > 2
              ).length > 0 && (
                  <>
                    <Button
                      variant="standard"
                      sx={{
                        borderRadius: 5,
                        fontSize: "10px",
                        backgroundColor: theme.palette.primary.main,
                        '&:hover': { backgroundColor: theme.palette.primary.light }
                      }}
                      endIcon={<DeleteSharp />}
                      autoFocus
                      onClick={recalculateBalancesList}
                    >
                      Calculate Cost
                    </Button>
                    |
                  </>
                )}
              {globalRoleSecurity.filter(
                (sec) => sec.Functionality === "Stock Balance" && sec.Security > 2
              ).length > 0 && (
                  <>
                    <Button
                      variant="standard"
                      sx={{
                        borderRadius: 5,
                        fontSize: "10px",
                        backgroundColor: theme.palette.primary.main,
                        '&:hover': { backgroundColor: theme.palette.primary.light }
                      }}
                      endIcon={<DeleteSharp />}
                      autoFocus
                      onClick={handleDelete}
                    >
                      Delete
                    </Button>
                    |
                  </>
                )}
              <Button
                variant="standard"
                sx={{
                  borderRadius: 5,
                  fontSize: "10px",
                  backgroundColor: theme.palette.primary.main,
                  '&:hover': { backgroundColor: theme.palette.primary.light }
                }}
                endIcon={<CloseSharp />}
                onClick={() => setOpen(false)}
                autoFocus
              >
                Close
              </Button>
            </DialogActions>
          </Dialog>
        )}
      </Formik>
    </div>
  );
}
